// Static setup-form configuration for the RCT experiment creation UI.
// The actual split preview / results numbers are computed server-side by
// the RCT design engine (see rctExperimentApi.ts) - nothing in this file is
// a stand-in for real data anymore.

export type SplitKey = "5050" | "8020" | "7030" | "6040";
export type SplitOption = SplitKey;

export const SPLIT_OPTIONS: { key: SplitOption; label: string }[] = [
  { key: "5050", label: "50 / 50" },
  { key: "6040", label: "60 / 40" },
  { key: "7030", label: "70 / 30" },
  { key: "8020", label: "80 / 20" },
];

// Test-group percentage sent to the backend as `modelParameterConfig.parameters.splits`.
export const SPLIT_PERCENTAGES: Record<SplitKey, number> = {
  "5050": 0.5,
  "6040": 0.6,
  "7030": 0.7,
  "8020": 0.8,
};

// Accepts `string` (not just SplitOption) because splitKey round-trips
// through the backend as an untyped string key.
export const splitLabel = (key: string): string =>
  SPLIT_OPTIONS.find((s) => s.key === key)?.label ?? key;

export interface SetupState {
  studyName: string;
  uploaded: boolean;
  file: File | null;
  uploadStatus: "idle" | "uploading" | "done";
  durations: number[];
  splits: SplitOption[];
  weeklyCap: number | null;
  totalWeeklySpend: number | null;
}

export const DEFAULT_SETUP_STATE: SetupState = {
  studyName: "",
  uploaded: false,
  file: null,
  uploadStatus: "idle",
  durations: [],
  splits: ["5050"],
  weeklyCap: null,
  totalWeeklySpend: null,
};
